import BusinessStatus from '../constants/business';
import { PhysicalModel, TypeEnseigne } from '../types/graphql-global-types';

export enum ApiErrorCode {
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  UNAUTHENTICATED = 'UNAUTHENTICATED', // User must be authentified to perform the action
  FORBIDDEN = 'FORBIDDEN', // User is not allowed to perform the action (ex: need admin right)
  BAD_USER_INPUT = 'BAD_USER_INPUT', // Front end input error
  UKNOWN_ERROR = 'UKNOWN_ERROR',
  NOT_FOUND = 'NOT_FOUND',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  WRONG_VALUE = 'WRONG_VALUE', // Wrong user input (ex: wrong email or wrong password)
  ALREADY_EXIST = 'ALREADY_EXIST',
  EXPIRED = 'EXPIRED', // When something is expired (ex: forgot password code)
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED', // Features not implemented yet (ex: get new password by phone)
  INVALID_TOKEN = 'INVALID_TOKEN',
  SENDINBLUE_HOST_NOT_FOUND = 'SENDINBLUE_HOST_NOT_FOUND', // Probably network error
  MAIL_NOT_WAS_SENT = 'MAIL_NOT_WAS_SENT',
  SMS_WAS_NOT_SENT = 'SMS_WAS_NOT_SENT',
  NOT_CONFIRMED = 'NOT_CONFIRMED',
  USER_ACCOUN_NOT_CONFIRMED = 'USER_ACCOUN_NOT_CONFIRMED',
  MANDATARY_ACCOUNT_NOT_CONFIRMED_BY_ADMIN = 'MANDATARY_ACCOUNT_NOT_CONFIRMED_BY_ADMIN',
  RUNTIME_ERROR = 'RUNTIME_ERROR', // Should never happen, otherwise something went wrong
  NEXTCLOUD_ERROR = 'NEXTCLOUD_ERROR',
  DUPLICATION_POSSIBILITY = 'DUPLICATION_POSSIBILITY',
  INVALID_USER_INPUT = 'INVALID_USER_INPUT',
  CGU_NOR_READ = 'CGU_NOR_READ',
  LINKEDIN_USER_NOT_FOUND = 'LINKEDIN_USER_NOT_FOUND',
}

export const BUSINESS_STATUSES: { [p: string]: string } = {
  [BusinessStatus.PENDING]: 'Attente consentement client',
  [BusinessStatus.ACCEPTED]: 'Contact transmis',
  [BusinessStatus.CONFIRMED]: 'Étude de faisabilité',
  [BusinessStatus.ADMISSIBLE]: 'Dossier recevable',
  [BusinessStatus.SCHEDULED_APPOINTMENT]: 'RDV programmé',
  [BusinessStatus.SIGNED_MANDATE]: 'Mandat signé',
  [BusinessStatus.BANK_SENT]: 'Dossier en banque',
  [BusinessStatus.CUSTOMER_FEEDBACK]: 'Accord de prêt',
  [BusinessStatus.OFFER_EDITED]: 'Offre éditée',
  [BusinessStatus.OFFER_SINGNED]: 'Dossier signé',
  [BusinessStatus.CLOSED]: 'Acte notarié signé',
  [BusinessStatus.COMMISSION_PAYED]: 'Commission payée',
  [BusinessStatus.PENDING_PROJECT]: 'Projet en attente',
  [BusinessStatus.REDIRECTED]: 'Dossier redirigé',
  [BusinessStatus.CANCELED]: 'Dossier annulé',
  [BusinessStatus.REJECTED]: 'Dossier irrecevable',
};

export enum DiscussionMessageTag {
  FEEDBACK = 'FEEDBACK',
  BUSINESS = 'BUSINESS',
  CONNECTCREDIT = 'CONNECTCREDIT',
}

export enum Civility {
  MISTER = 'MISTER',
  MADAME = 'MADAME',
}

export const CIVILITIES = {
  [Civility.MISTER]: 'Monsieur',
  [Civility.MADAME]: 'Madame',
};

export enum Role {
  ESTATE_OFFICIER = 'ESTATE_OFFICIER', // Agent ou mandataire immobilier
  WEALTH_ADVISOR = 'WEALTH_ADVISOR', // Conseiller patrimonial
  NOTARY = 'NOTARY',
  INDIVIDUAL = 'INDIVIDUAL', // Particulier
  PROMOTER = 'PROMOTER', // Promoteur ou constructeur
  MANDATARY = 'MANDATARY', // Expert CC
  ADMIN = 'ADMIN',
  VICE_MANAGER_CC = 'VICE_MANAGER_CC', // Gestionnaire
  MANAGER_CC = 'MANAGER_CC',
  ALL = 'ALL', // Autre
}

export const APAS = [
  Role.ESTATE_OFFICIER,
  Role.WEALTH_ADVISOR,
  Role.NOTARY,
  Role.INDIVIDUAL,
  Role.PROMOTER,
];

export const ROLES: { [p: string]: string } = {
  [Role.ESTATE_OFFICIER]: 'Agent immobilier',
  [Role.PROMOTER]: 'Promoteur immobilier',
  [Role.WEALTH_ADVISOR]: 'Conseiller patrimonial',
  [Role.NOTARY]: 'Notaire',
  [Role.INDIVIDUAL]: 'Particulier',
  [Role.MANDATARY]: 'Expert Connectcrédit',
  [Role.VICE_MANAGER_CC]: 'Gestionnaire Connectcrédit',
  [Role.MANAGER_CC]: 'Manager Connectcrédit',
  [Role.ADMIN]: 'Administrateur',
  [Role.ALL]: 'Autre',
};

export enum Resource {
  BACKOFFICE = 'BACKOFFICE',
  MOBILE = 'MOBILE',
  //
  ENSEIGNES = 'ENSEIGNES',
  ENTITIES = 'ENTITIES',
  USERS = 'USERS',
  BUSINESSES = 'BUSINESSES',
  FEEDBACKS = 'FEEDBACKS',
  COMPAIGNS = 'COMPAIGNS',
  RATES = 'RATES',
  ROLES = 'ROLES',
  DISCUSSIONS = 'DISCUSSIONS',
}

export const RESOURCES: { [p: string]: string } = {
  [Resource.BACKOFFICE]: 'Backoffice',
  [Resource.MOBILE]: 'Mobile',
  //
  [Resource.ENSEIGNES]: 'Enseignes',
  [Resource.ENTITIES]: 'Entités',
  [Resource.USERS]: 'Utilisateurs',
  [Resource.BUSINESSES]: 'Affaires',
  [Resource.FEEDBACKS]: 'Feedbacks',
  [Resource.COMPAIGNS]: 'Campagnes',
  [Resource.RATES]: 'Taux',
  [Resource.ROLES]: 'Rôles',
  [Resource.DISCUSSIONS]: 'Discussions',
};

export enum Operation {
  CREATE = 'CREATE',
  READ = 'READ',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  IMPORT = 'IMPORT',
  EXPORT = 'EXPORT',
}

export const OPERATIONS: { [p: string]: string } = {
  [Operation.READ]: 'Afficher',
  [Operation.CREATE]: 'Créer',
  [Operation.UPDATE]: 'Modifier',
  [Operation.DELETE]: 'Supprimer',
  [Operation.IMPORT]: 'Importer',
  [Operation.EXPORT]: 'Exporter',
};

export const PHYSICAL_MODEL = {
  [PhysicalModel.WITHOUT_AGENCY]: 'Sans agence',
  [PhysicalModel.WITH_AGENCY]: 'Avec agence(s)',
};

export const TYPE_ENSEIGN = {
  [TypeEnseigne.BANK]: 'BANQUE',
  [TypeEnseigne.CONNECTCREDIT]: 'CONNECTCREDIT',
  [TypeEnseigne.NOTARIAT]: 'NOTARIAT',
  [TypeEnseigne.REAL_ESTATE_TRANSACTION]: 'TRANSACTION IMMOBILIERE',
  [TypeEnseigne.REAL_ESTATE_PROMOTION]: 'PROMOTION IMMOBILIERE',
  [TypeEnseigne.HERITAGE_MANAGEMENT]: 'GESTION PATRIMONIALE',
  [TypeEnseigne.INSURANCE]: 'ASSURANCE',
  [TypeEnseigne.PARRAINAGE]: 'PARRAINAGE',
  [TypeEnseigne.OTHER]: 'AUTRES',
};

export enum EnseigneTag {
  CONNECTCREDIT = 'CONNECTCREDIT',
}

export enum EchelonPriority {
  RESEAU = 1,
  DIVISIONS = 2,
  PAYS = 3,
  REGIONS = 4,
  VILLE = 5,
  DEPARTEMENTS = 6,
  SECTEURS = 7,
  GROUPEMENTS = 8,
  AGENCES = 9,
  EQUIPE = 10,
}

export const EchelonName = {
  RESEAU: 'RESEAU (CROSS-ENSEIGNES)',
  DIVISIONS: 'DIVISION',
  PAYS: 'PAYS',
  REGIONS: 'REGION',
  VILLE: 'VILLE',
  DEPARTEMENTS: 'DEPARTEMENT',
  SECTEURS: 'SECTEUR',
  GROUPEMENTS: 'GROUPEMENT',
  PRETEUR: 'PRETEUR',
  AGENCE_CONNECTCREDIT: 'AGENCE CONNECTCREDIT',
  AGENCES: 'AGENCE',
  EQUIPE: 'EQUIPE',
};

export const GraphqlError = {
  CRM_ID_EXIST: 'CRM_ID_EXIST',
};
